















import { Vue, Component } from 'vue-property-decorator';
import { Banner, NewsList } from '@/components';
import { Icon } from 'vant';
import { getBaseinfo } from '@/api/api';
Vue.use(Icon);
@Component({
  components: {
    Banner,
    NewsList,
  },
})
export default class Home extends Vue {
  bannerSrc = require('./assets/banner.jpg');
  extendVal: boolean = false;

  created() {
    getBaseinfo('2020project/2020entrust').then((res: any) => {
      this.$addPv(res.data.activityId);
      console.log('活动id', res.data.activityId);
    });
    setTimeout(() => {
      this.$appShareInfo({
        title: '不负嘱托 奋斗有我',
        url: window.location.href,
        subtitle: '榜样面对面脱贫攻坚先进事迹微视频宣讲活动',
        classId: -1,
        id: -1,
        image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
        type: 3,
      });
    }, 100);
    this.$wxShareInfo({
      title: '不负嘱托 奋斗有我',
      subtitle: '榜样面对面脱贫攻坚先进事迹微视频宣讲活动',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  handleClickExtend() {
    this.extendVal = !this.extendVal;
  }
}
